import { Avatar } from "primereact/avatar"
import { Button } from "primereact/button"
import { Rating } from "primereact/rating"

const CustomerSatisfaction = () => {
    return (
        <>
            <div className="flex justify-content-between align-items-center">
                <Button
                    className="benefitsCaruselButton"
                    icon="pi pi-angle-left"
                    style={{
                        borderRadius: "50%",
                        width: "3.5rem",
                        height: "3.5rem",
                        background: "white",
                        border: "1px solid #2D3967",
                        color: "#2D3967",
                        paddingTop: "0.75rem",
                        paddingBottom: "0.75rem",
                        paddingLeft: "1.5rem",
                        paddingRight: "1.5rem"
                    }} />
                <div className="flex flex-column align-items-center gap-4">
                    <Avatar image="/JonathonProfileImage.jpg" size="xlarge" className="w-10rem h-10rem" style={{ backgroundColor: '#BEC2D0', }} shape="circle" />
                    <p className="m-0 font-bold text-center" style={{ color: "#2D3967", fontSize: "1.75rem" }} >Jonathon Smith</p>
                    <p className="m-0 text-lg" style={{ color: "#727A99" }} >1 year ago </p>
                    <p className="m-0 text-xl text-center" style={{ color: "#727A99", maxWidth: "40rem" }}>“ Mobithera made my recovery after knee surgery so much easier. The AI feedback helped me do every movement correctly, and I could feel myself getting stronger each week. I loved being able to monitored by my doctor through the process! “ </p>
                    <Rating value={3} readOnly cancel={false} />
                </div>
                <Button
                    icon="pi pi-angle-right"
                    className="benefitsCaruselButton"
                    style={{
                        borderRadius: "50%",
                        width: "3.5rem",
                        height: "3.5rem",
                        padding: "0",
                        background: "white",
                        border: "1px solid #2D3967",
                        color: "#2D3967",
                        paddingTop: "0.75rem",
                        paddingBottom: "0.75rem",
                        paddingLeft: "1.5rem",
                        paddingRight: "1.5rem"
                    }} />
            </div>

        </>
    )
}

export default CustomerSatisfaction